export const createEmptyPlot = () => ({
  primaries: [],
  secundaries: [],
  tertiaries: [],
});

export const isPlotValid = (plot) => {
  if (!plot) return false;

  return ["primaries", "secundaries", "tertiaries"].some(
    (key) => Array.isArray(plot[key]) && plot[key].length > 0
  );
};

export const normalizePlot = ({ source, items = [] }) => {
  const plot = createEmptyPlot();

  const categoryMap = {
    1: "primaries",
    2: "secundaries",
    3: "tertiaries",
    PRINCIPAL: "primaries",
    SECUNDARIA: "secundaries",
    TERCIARIA: "tertiaries",
  };

  items.forEach((item) => {
    const categoryKey =
      categoryMap[item.relevance] ||
      categoryMap[item?.data?.category];

    if (!categoryKey) return;

    const data = item?.data || item;

    plot[categoryKey].push({
      id: source === "API" ? data?.id : 0,
      name: data?.name || item?.thesaurus?.name,
      thesaurusId:
        item?.thesaurusId ||
        item?.thesaurus?.id ||
        data?.thesaurusId ||
        data?.id ||
        null,
      description:
        categoryKey === "primaries"
          ? "Central"
          : categoryKey === "secundaries"
          ? "Secondary"
          : "Terciary",
      descriptionContext:
        data?.justification || item?.description || null,
      origin: source,
      generatedByAI: source === "AI",
      field: "Trama",
    });
  });

  return plot;
};
